import axios from "axios";
import { BASE_API_URL } from "../Api/constants";
import { getCurrentLang } from "../utils/lang";
const abortController = new AbortController();
const apiClient = axios.create({
  baseURL: BASE_API_URL,
  signal: abortController.signal,
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const currentLang = getCurrentLang();
    if (token) {
      config.headers["X-T"] = `Bearer ${token}`;
    }
    config.headers["Local"] = currentLang;
    delete config.headers["Authorization"];
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export const ApiClient = apiClient;

export const getDashboardData = () => {
  return apiClient.get(`/client`);
};
export const getUsageLimit = (CustomerID) => {
  return apiClient.get(`/usage/${CustomerID}`);
};
export const incrementUsageLimit = (CustomerID) => {
  return apiClient.post(`/usage/${CustomerID}/increment`);
};


export const getContracts = (customerId) => {
  return apiClient.get(`/client/${customerId}`, {
    params: { Limit: 100, Page: 1, Type: "Basic" },
  });
};

export const getContractHistory = (contractId) => {
  return apiClient.get(`/client/history/${contractId}`);
};

// tree data mock
export const getDocumentTree = (contractId) => {
  return apiClient.get(`/client/file/${contractId}`, {
    params: { Type: "Documents" },
  });
};

export const getFilesList = (historyId, type = "Billing") => {
  return apiClient.get(`/client/file/${historyId}`, {
    params: { Type: type },
  });
};

export const getFileAsBlob = (fileId, type = "View") => {
  return apiClient.get(`/file`, {
    params: { Type: type, Id: fileId },
    responseType: "blob",
  });
};

export const getContractService = (historyId) => {
  return apiClient.get(`/client/service/${historyId}`);
};

export const getFileUrl = (fileId, type = "View") => {
  // GET /root/file?Type=View&Id=1

  return `${BASE_API_URL}root/file?Type=${type}&Id=${fileId}`;
};
export const UploadChunk = ({ UploadId, ChunkIndex, body, TempId }) => {
  return apiClient.post(
    `/file/upload-chunk?UploadId=${UploadId}&ChunkIndex=${ChunkIndex}&TempId=${TempId}`,
    body
  );
};

export const mergeFileChunks = (data) => {
  return apiClient.post("/folder/file", data);
};

export const deleteMessage = (MessageId) => {
  return apiClient.delete(`/msg?MessageId=${MessageId}`);
};
export const uploadFileManagerChunk = ({ UploadId, ChunkIndex, body }) => {
  return apiClient.post(
    `/folder/file/upload-chunk?UploadId=${UploadId}&ChunkIndex=${ChunkIndex}`,
    body
  );
};
export const mergeFileManagerChunks = (data) => {
  return apiClient.post("/folder/file", data);
};
export const uploadChunkForFileManager = ({
  UploadId,
  ChunkIndex,
  TempId,
  body,
}) => {
  return apiClient.post(
    `/file/upload-chunk?UploadId=${UploadId}&ChunkIndex=${ChunkIndex}&TempId=${TempId}`,
    body
  );
};
export const getProjectFileForView = (fileId) => {
  return apiClient.get(`/folder/file/${fileId}`, {
    params: { Type: "View" },
    responseType: "blob",
  });
};

// export const getFoldersByContract = (contractId) => {
//   return apiClient.get(`/folder`, {
//     params: {
//       ContractId: contractId
//     }
//   });
// };
export const getFoldersByContract = (contractId) => {
  return apiClient.get(`/folder/${contractId}`);
};

// export const getFolderContents = (folderId) => {
//     return apiClient.get(`/folder`, {
//         params: {
//             Id: folderId
//         }
//     });
// }
export const getFolderContents = (contractId, folderId) => {
  return apiClient.get(`/folder/${contractId}`, { params: { Id: folderId } });
};

export const getProjectFolders = (contractId, Name) => {
  return apiClient.get(`/folder`, { 
    params: { 
      ContractId: contractId,
      ...(Name && { Name })
    } 
  });
};

export const createFolder = (data) => {
  return apiClient.post("/folder", data);
};

export const updateFolder = (folderId, data) => {
  return apiClient.put(`/folder/${folderId}`, data);
};

export const deleteFolder = (folderId) => {
  return apiClient.delete(`/folder/${folderId}`);
};

export const updateFolderFile = (fileId, data) => {
  return apiClient.put(`/folder/file/${fileId}`, data);
};

export const deleteFolderFile = (fileId) => {
  return apiClient.delete(`/folder/file/${fileId}`);
};

export const updateProjectFile = (fileId, data) => {
  return apiClient.put(`/folder/file/${fileId}`, data);
};
export const deleteProjectFile = (fileId) => {
  return apiClient.delete(`/folder/file/${fileId}`);
};

export const renewSubscription = (renewalData) => {
  return apiClient.post("/client/renewal", renewalData);
};
